export default __webpack_public_path__ + "static/media/9.38c11684.png";